import { http } from '@/utils/http'
export interface IFooItem {
  id: string
  name: string
}

// 验证码登录
export const mobileLogin = (data) => {
  return http.get<IFooItem>('/wxapp/mobileLogin', data)
}
// 获取验证码
export const sendSmCode = (data) => {
  return http.post<IFooItem>('/unionCloud/login/sendSmCode', '', data)
}
// 用户注册
export const clientRegister = (data) => {
  return http.post<IFooItem>('/wxapp/clientRegister', '', data)
}
// 获取微信信息
export const getWxInfo = (data) => {
  return http.get<IFooItem>('/wxapp/wxApi/getWxInfo', data)
}
// 获取微信信息
export const getPhone = (data) => {
  return http.get<IFooItem>('/wxapp/wxApi/getPhone', data)
}
// 注册
export const wxClientRegister = (data) => {
  return http.post<IFooItem>('/wxapp/clientRegister', '', data)
}
// 微信登录
export const wxLogin = (data) => {
  return http.post<IFooItem>('/wxapp/wxLogin', '', data)
}
// 微信登录
export const refreshToken = (data) => {
  return http.post<IFooItem>('/wxapp/refreshToken', '', data)
}
